import { render } from "./ui-textarea.vue?vue&type=template&id=5dbd93ac"
import script from "./ui-textarea.vue?vue&type=script&lang=js"
export * from "./ui-textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__